
const state = () => ({
  /*
  The current state of the layout which an array of tile objects:
  [
    {
      i: the identifier for this tile
      x: the x position of the tile
      y: the y position of the tile
      hidden: whether or not the tile is hidden
      w: the width of the tile
      h: the height of the tile
      component: the componenet rendered on the tile
      componentProps: the props to pass to the component on the tile
    }
  ]
  */
  layout: null,
  breakpoint: 'lg',
  breakpoints: {sxl: 2100, xxxl: 1920, xxl: 1661, xl: 1421, lg: 1181, md: 1107, sm: 1021, xs: 768, xxs: 400 },
  columnsByBreakpoint: {sxl: 6, xxxl: 5, xxl: 5, xl: 4, lg: 3, md: 3, sm: 2, xs: 2, xxs: 1 },
  rowHeightByBreakpoint: {sxl: 320, xxxl: 340, xxl: 308, xl: 325, lg: 360, md: 315, sm: 410, xs: 380, xxs: 540 },
  version: 0
})

// getters
const getters = {
  getLayout: (state, getters) => {
    return state.layout
  },
  isNonNullState(state, getter) {
    if(state.layout) {
      return true
    }
    return false
  },
  getVersion: (state, getters) => {
    return state.version
  },
  getBreakpoint: (state, getters) => {
    return state.breakpoint
  },
  getBreakpoints: (state, getters) => {
    return state.breakpoints
  },
  getColumns: (state, getters) => {
    return state.columnsByBreakpoint[`${state.breakpoint}`]
  },
  getColumnsByBreakpoint: (state, getters) => {
    return state.columnsByBreakpoint
  },
  getRowHeight: (state, getters) => {
    return state.rowHeightByBreakpoint[`${state.breakpoint}`]
  },
}

// actions
const actions = {
  getTilesHiddenState(context, tile) {
    var tile = context.state.layout.find(storeTile => storeTile.i === tile.i)
    return tile.hidden
  },
  resetLayoutToInitialState(context, initialLayout) {
    var numColumns = context.getters['getColumns']
    var layout = null
    if (initialLayout){
      layout = initialLayout
    }
    else {
      layout = context.getters['getLayout']
    }
    var y = 0;
    var x = 0;
    for (var i = 0; i < layout.length; i++) {
      layout[i].i = i;
      if ((x + layout[i].w) > numColumns) {
        x = 0;
        y += Math.max.apply(Math, layout.map(function(o) { return o.h; }))
      }
      layout[i].x = x;
      layout[i].y = y;
      layout[i].hidden = false;
      x += layout[i].w;
    }
    context.commit('saveLayout', layout)
  },
  updateTileComponentProp(context, parameters) {
    var layout = context.getters['getLayout']
    var savedTile = layout.find(storeTile => storeTile.name === parameters.name)
    savedTile.componentProps[parameters.propertyName] = parameters.propertyValue
    context.commit('saveLayout', layout)
  },
  syncUpdatedInitialTileData(context, newInitialTileData) {
    // Get the layout
    var layout = context.getters['getLayout']
    if (!layout) {
      layout = []
    }
    // Mark each tile of the newInitialTileData as unprocessed
    if(newInitialTileData) {
      for (var unprocessedCard of newInitialTileData) {
        unprocessedCard.processed = false
      }
    }
    // Create list to keep track of tiles to remove
    var tilesToRemove = []
    // Iterate through the current layout of tiles
    for (var tile of layout) {
      // Find the current card in the newInitialTileData
      var tileProp = newInitialTileData.find(card => card.name == tile.name)
      // If the card cannot be found in the new tiles prop (it has been removed)
      if(!tileProp) {
        // flag for removal from the layout
        tilesToRemove.push(tile)
      }
      else {
        // update the card with new initial card data
        tile.w = tileProp.w
        tile.h = tileProp.h
        if('modal' in tileProp){
          if ('width' in tileProp.modal){
            tile.modal.width = tileProp.modal.width
          }
        }
        tileProp.processed = true
      }
    }
    // Remove the tiles from the layout that have been flagged for removal
    for (var tileToRemove of tilesToRemove) {
      var indexOfTileInLayout = layout.findIndex(x => x.name === tileToRemove.name)
      layout.splice(indexOfTileInLayout, 1)
    }
    // Find out what cards from the new tiles props have not been processed. These are new tiles
    var newTiles = newInitialTileData.filter(x => x.processed == false)
    var numColumns = context.getters['getColumns']
    // Iterate through the new tiles and add them in
    for(var newTile of newTiles) {
      // if the layout isnt empty
      if (layout.length > 0) {
          // get last item in layout
          // So we shouldnt get the last tile we should get the tile with the greatest Y and then get the tile with the greatest X
          var listOfYs = layout.map((tile) => {return tile.y}) 
          var greatestY = Math.max.apply(Math, listOfYs)
          var listOfTilesWithGreatestYs = layout.filter((tile) => { if(tile.y == greatestY){return true} })
          var listOfXsOfTilesWithGreatestYs = listOfTilesWithGreatestYs.map((tile) => { return tile.x } )
          var greatestX = Math.max.apply(Math, listOfXsOfTilesWithGreatestYs)
          var lastTile = layout.find(card => card.y == greatestY && card.x == greatestX)
          // calculate the new tiles x,y,i
          var newTileI = lastTile.i + 1
          var newTileX = lastTile.x + lastTile.w
          var newTileY = lastTile.y
          if ((newTileX + newTile.w) >= numColumns) {
            newTileX = 0
            newTileY = lastTile.y + Math.max.apply(Math, layout.map((tile) => { return tile.h; }))
          }
      }
      // if the layout is empty
      else {
        var newTileX = 0
        var newTileY = 0
        var newTileI = 0
      }
      // Set new tiles x,y,i
      newTile.i = newTileI
      newTile.x = newTileX;
      newTile.y = newTileY;
      newTile.hidden = false;
      // add new tile to layout
      layout.push(newTile)
    }
    // Save new layout
    context.commit('saveLayout', layout)
    return true
  },
}

// mutations
const mutations = {
  saveLayout(state, layout) {
    state.layout = layout
  },
  saveTileHiddenState(state, tile) {
    state.layout.find(storeTile => storeTile.i === tile.i).hidden = tile.hidden
  },
  resetState(state) {
    state.layout = null
  },
  setVersion(state, version) {
    state.version = version
  },
  setBreakpoint(state, breakpoint) {
    state.breakpoint = breakpoint
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
